export const organisationTypeMap = [
  {
    title: "Broker",
    value: "broker",
  },
  {
    title: "Customer",
    value: "customer",
  },
];
